var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "updates", title: "Updates" } },
    [
      _c("template", { slot: "copy" }, [
        _c("p", [_vm._v("This agreement covers:")]),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticClass: "fa-ul",
            staticStyle: {
              "--fa-li-width": "4em",
              "--margin-bottom": "var(--spacing-2xl)",
              "--margin-top": "var(--spacing-2xl)",
            },
          },
          [
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v("\n        currently available\n        "),
              _c("em", [_vm._v("Pro Icons")]),
              _vm._v(", and any new\n        "),
              _c("em", [_vm._v("Pro Icons")]),
              _vm._v("\n        the\n        "),
              _c("em", [_vm._v("Company")]),
              _vm._v("\n        releases as part of\n        "),
              _c("em", [_vm._v("Font Awesome Pro")]),
              _vm._v("\n        during the term of this agreement.\n      "),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v("\n        current versions of\n        "),
              _c("em", [_vm._v("Pro Software")]),
              _vm._v(", and any new versions of\n        "),
              _c("em", [_vm._v("Pro Software")]),
              _vm._v("\n        the\n        "),
              _c("em", [_vm._v("Company")]),
              _vm._v(
                "\n        releases during the term of this agreement\n      "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("After this Agreement Ends"),
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v("\n      When this agreement ends, the\n      "),
            _c("em", [_vm._v("Customer")]),
            _vm._v(
              "'s license continues for versions already covered by this agreement under "
            ),
            _c("site-link", { attrs: { to: { hash: "#updates" } } }, [
              _vm._v("Updates"),
            ]),
            _vm._v(".\n      The "),
            _c("em", [_vm._v("Customer")]),
            _vm._v(
              "'s license will not cover new versions released after this agreement ends. The\n      "
            ),
            _c("em", [_vm._v("Customer")]),
            _vm._v("\n      may continue to add and remove\n      "),
            _c("em", [_vm._v("Creators")]),
            _vm._v("\n      under\n      "),
            _c("site-link", { attrs: { to: { hash: "#manage-creators" } } }, [
              _vm._v("Manage Creators"),
            ]),
            _vm._v(".\n    "),
          ],
          1
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v(
            "Exception for certain Limited License Customers Following End of Agreement"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Notwithstanding anything to the contrary herein, if the plan purchased by a Limited License Customer does not include a perpetual license, such Limited\n      License Customer shall not be permitted to use Pro Icons after their subscription ends and this agreement is terminated.\n    "
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }